import { forwardRef } from 'react';
import cn from 'classnames';
import { Overlay as BaseOverlay, type OverlayProps } from '@direct-frontend/components';
import styles from './Overlay.module.css';

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>(function Overlay(props, forwardedRef) {
    const { className, children, ...other } = props;

    return (
        <BaseOverlay ref={forwardedRef} {...other} className={cn(className, styles.overlay)}>
            {children}
        </BaseOverlay>
    );
});
